export const GET_API_URL = () => {
    // production url:
    if (window.location.protocol == "https:" && window.location.hostname !== "localhost")
        return `https://${window.location.hostname}/api/`;

    // dev url"
    return `${window.location.protocol || ":"}//${window.location.hostname}:3001/`
}   